import Head from 'next/head'
import { StructuredText } from 'react-datocms'
import styled from 'styled-components'
import { OurStudiesPageRecord } from 'types'

import { CentredContentBlock } from '@/components/blocks/CentredContentBlock'
import { SciencePagePredictStudiesBlock } from '@/components/blocks/SciencePagePredictStudiesBlock'
import { SciencePageStudiesGroupBlock } from '@/components/blocks/SciencePageStudiesGroupBlock'
import { Footer } from '@/components/elements/footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { ScienceSubNavigation } from '@/components/elements/science/ScienceSubNavigation'

type OurStudiesPageProps = {
  page: OurStudiesPageRecord
}

const StyledCenteredContentBlock = styled.div`
  h1 {
    margin-bottom: 32px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      font-size: ${(p) => p.theme.v2.typography.display.xxs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.display.xxs.lineHeight};
    }
  }

  p {
    max-width: 760px;
    margin-top: 0;
    margin-bottom: 0;
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    color: ${(props) => props.theme.v2.onSurface.subduedText};

    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
    }
  }

  a.button {
    margin-top: 40px;
  }
`

const renderBlock = ({ record }) => {
  switch (record.__typename) {
    case 'CentredContentBlockRecord':
      return (
        <>
          <StyledCenteredContentBlock>
            <CentredContentBlock record={record} key={record.id} />
          </StyledCenteredContentBlock>

          <SciencePagePredictStudiesBlock />
        </>
      )
    case 'SciencePageStudiesGroupRecord':
      return <SciencePageStudiesGroupBlock record={record} key={record.id} />
    default:
      return null
  }
}

export const OurStudiesPage: React.FC<OurStudiesPageProps> = ({ page }) => {
  return (
    <>
      <Head>
        <title>Our Studies</title>
        <link rel="canonical" href={`${process.env.SITE_URL}/our-studies`} />
      </Head>

      <Header backgroundColor="white" />

      <ScienceSubNavigation selected="/our-studies" />

      <main id="main-content">
        <StructuredText data={page.content} renderBlock={renderBlock} />
      </main>

      <Footer showPreFooter />
    </>
  )
}
